import { render, staticRenderFns } from "./OrangeCommitments.vue?vue&type=template&id=367a3ad0&"
import script from "./OrangeCommitments.vue?vue&type=script&lang=js&"
export * from "./OrangeCommitments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('367a3ad0')) {
      api.createRecord('367a3ad0', component.options)
    } else {
      api.reload('367a3ad0', component.options)
    }
    module.hot.accept("./OrangeCommitments.vue?vue&type=template&id=367a3ad0&", function () {
      api.rerender('367a3ad0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/components/OrangeCommitments.vue"
export default component.exports